export default __webpack_public_path__ + "static/icon-awtgs-grade-2-260x260-546bca2ae071d8ae5cb3dbc151191c74.jpg";